import { ADD_GBIFI_TOKEN, ADD_BIFI_TOKEN } from './address';

class Token {
  public id: string;
  public address: string;
  public symbol: string;
  public image: string | undefined;
  public type: string;
  public decimals: number;
  public name: string;

  constructor(
    id: string,
    address: string,
    symbol: string,
    image: string | undefined = undefined,
    type: string = 'ERC20',
    decimals: number = 18,
    name: string = '',
  ) {
    this.id = id;
    this.address = address;
    this.symbol = symbol;
    this.image = image;
    this.type = type;
    this.decimals = decimals;
    this.name = name || this.symbol;
  }
}

const tokens: Token[] = [
  new Token(
    'gbifi',
    ADD_GBIFI_TOKEN,
    'GBiFi',
    'https://s3.ap-northeast-2.amazonaws.com/bifi.finance/icon/gbifi.svg'
  ),
  new Token(
    'bifi',
    ADD_BIFI_TOKEN,
    'BiFi',
    'https://s3.ap-northeast-2.amazonaws.com/bifi.finance/icon/bifi.png'
  )
];

export default tokens;

export { Token };
